import React, { useCallback } from 'react'
import PropTypes from 'prop-types'

import CountryOrRegionMultiSelect from '../CountryOrRegionMultiSelect'
import ErrorMessage from '../../../../components/Form/ErrorMessage'
import Checkbox from '../../../../components/Form/Checkbox'

import { EXCLUDE_LOCATIONS_CHECKBOX, GEO_EXCLUSIONS } from '../fields'

import useDrawerFormStyles from '../../../../styles/common/drawerForms'
import useStyles from './styles'

const GeolocationsExclusions = ({ formik }) => {
  const drawerFormClasses = useDrawerFormStyles()
  const classes = useStyles()

  const { values, errors, touched, setFieldValue } = formik

  const excludeLocationsCheckboxHandler = useCallback(() => {
    setFieldValue(EXCLUDE_LOCATIONS_CHECKBOX, !values[EXCLUDE_LOCATIONS_CHECKBOX])
  }, [values, setFieldValue])

  return (
    <section className={drawerFormClasses.section}>
      <Checkbox
        id="exclude_locations_checkbox"
        title="Exclude locations"
        isLarge
        name={EXCLUDE_LOCATIONS_CHECKBOX}
        checked={values[EXCLUDE_LOCATIONS_CHECKBOX]}
        onCheck={excludeLocationsCheckboxHandler}
        className={classes.excludeLocationsCheckbox}
      />
      {values[EXCLUDE_LOCATIONS_CHECKBOX] && (
        <>
          <CountryOrRegionMultiSelect formik={formik} name={GEO_EXCLUSIONS} placeholder="Search..." />
          {errors[GEO_EXCLUSIONS] && touched[GEO_EXCLUSIONS] && <ErrorMessage error={errors[GEO_EXCLUSIONS]} />}
        </>
      )}
    </section>
  )
}

GeolocationsExclusions.propTypes = {
  formik: PropTypes.object.isRequired
}

export default GeolocationsExclusions
